import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'color-simple-control',
    templateUrl: 'color-simple.control.html',
    standalone: false,
})
export class ColorSimpleControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() modelValue!: string;
    @Output() modelValueChange = new EventEmitter<string>();

    @Input() label?: string;
    @Input() disabled?: boolean;
    @Input() required?: boolean;
    @Input() name?: string;
    @Input() id?: string;
    @Input() title?: string;
}
